type getPageResourceProps = {
	urls: string[];
	onPDFReady?: (html: string) => void;
};

export const downloadPages = async ({ urls, onPDFReady }: getPageResourceProps) => {
	try {
		const responses = await Promise.all(
			urls.map((url) => {
				const urlWithParam = `${url}?timestamp`;
				return fetch(urlWithParam, {
					credentials: 'include',
				});
			})
		);
		const html = await Promise.all(
			responses.map((response) => {
				if (response.ok) {
					return response.text();
				}
				throw new Error('Error loading content.');
			})
		);

		const container = document.createElement('div');
		html.forEach((htmlStr) => {
			const doc = new DOMParser().parseFromString(htmlStr, 'text/html');
			const content = doc.getElementsByTagName('main')[0];
			if (content) {
				return container.appendChild(content);
			}

			return;
		});

		const processedHTML = generatePdf(container);
		if (onPDFReady) {
			return onPDFReady(processedHTML.innerHTML);
		}
	} catch (err) {
		console.log('failed to load ', urls, err);
	}
};

export const generatePdf = (documentPrintables: HTMLElement): HTMLElement => {
	documentPrintables.childNodes.forEach(async (elem: HTMLElement, index: number) => {
		const dateDownloaded = elem.querySelector('#contentOverviewDownloadHeader') as HTMLElement;
		if (dateDownloaded !== null && index === 0) {
			dateDownloaded.style.display = 'block';
		}
		const videoContainer = elem.querySelectorAll('#videoContainer');
		const iframeContainer = elem.querySelectorAll('iframe');

		if (videoContainer) {
			videoContainer.forEach((videos) => {
				const video = videos as HTMLElement;
				video.style.display = 'none';
			});
		}

		if (iframeContainer) {
			iframeContainer.forEach((iframes) => {
				const iframe = iframes as HTMLElement;
				iframe.style.display = 'none';
			});
		}
	});

	return documentPrintables;
};
